import { Button } from '@/lib';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type SmsSenderListErrorStateProps = {
  onRetry: () => void;
};

export const SmsSenderListErrorState: FC<SmsSenderListErrorStateProps> = ({ onRetry }) => {
  const { t } = useTranslation('campaign');

  return (
    <div className='flex flex-col items-center justify-center gap-4 rounded-2xl border border-secondary-border bg-white py-16'>
      <h3 className='text-lg font-semibold text-slate-900'>{t('smsWorkspace.senders.failedToLoadSenders')}</h3>
      <p className='text-secondary-600 max-w-md text-center text-sm'>{t('smsWorkspace.senders.failedToLoadSendersDescription')}</p>
      <Button intent='secondary' onClick={onRetry} text={t('smsWorkspace.senders.tryAgain')} />
    </div>
  );
};
